import { useState } from "react";
import { useTranslation } from "react-i18next";

import useDocumentTitle from "../../utils/useDocumentTitle";

import styles from "./Dashboard.module.scss";

import PageContent from "../../components/PageContent";
import Section from "../../components/Section";
import SectionTitle from "../../components/SectionTitle";
import { Tab, Tabs } from "../../components/Tabs";
import { DashboardLayout } from "../../layouts/DashboardLayout";
import { getLocalValue } from "../../utils/auth";

import {
  IsCampaignAdmin,
  IsCEO,
  IsCoach,
  IsCoachee,
  IsCOEAdmin,
  IsCoordinator,
  IsExecutive,
} from "../../config/Roles";

import CampaignList from "../../components/CampaignList";
import GetAllCountries from "../../components/GetAllCountries";
import CampaignDashboard from "./CampaignDashboard";
import CEODashboard from "./CEODashboard";
import COEDashboard from "./COEDashboard";
import ExecutiveDashboard from "./ExecutiveDashboard";
import PersonalDashBoard from "./PersonalDashboard";
import TeamDashboard from "./TeamDashboard";

import "../../translations/i18n";

export function Dashboard(props) {
  const uid = getLocalValue("uid");
  const { t } = useTranslation();
  useDocumentTitle(props.title);
  const [selectedCountry, setSelectedCountry] = useState(null);
  return (
    <DashboardLayout>
      <div className={styles.pageWrapper}>
        <PageContent>
          <Section>
            <SectionTitle>{t("leftNavigation.scoresheet")}</SectionTitle>

            {IsCoach() && !IsCampaignAdmin() && !IsCOEAdmin() && (
              <Tabs>
                <Tab
                  label={"team"}
                  tabName={t("dashboard.tabs.team")}
                  defaultTab={true}
                >
                  <TeamDashboard />
                </Tab>
                <Tab label={"personal"} tabName={t("dashboard.tabs.personal")}>
                  <PersonalDashBoard />
                </Tab>
              </Tabs>
            )}

            {IsCampaignAdmin() && !IsCOEAdmin() && (
              <Tabs>
                <Tab
                  label={"campaign"}
                  tabName={t("dashboard.tabs.campaign")}
                  defaultTab={true}
                >
                  <CampaignDashboard />
                </Tab>
                <Tab label={"team"} tabName={t("dashboard.tabs.team")}>
                  <TeamDashboard />
                </Tab>
              </Tabs>
            )}

            {IsCOEAdmin() && (
              <Tabs>
                <Tab
                  label={"COE"}
                  tabName={t("dashboard.tabs.coe")}
                  defaultTab={IsCOEAdmin()}
                >
                  <COEDashboard />
                </Tab>
                <Tab label={"campaign"} tabName={t("dashboard.tabs.campaign")}>
                  <CampaignDashboard />
                </Tab>
              </Tabs>
            )}

            {IsExecutive() | IsCEO() ? (
              <Tabs>
                {IsCEO() ? (
                  <Tab
                    label={"CEO"}
                    tabName={t("dashboard.tabs.ceo")}
                    defaultTab={IsCEO()}
                  >
                    <CEODashboard />
                  </Tab>
                ) : null}
                <Tab
                  label={"executive"}
                  tabName={t("dashboard.tabs.executive")}
                  defaultTab={IsExecutive()}
                >
                  <div
                    className={styles.stickyHeader}
                    style={{ left: "300px" }}
                  >
                    {IsExecutive() && (
                      <GetAllCountries
                        showAllCountry={false}
                        api={`/api/getUserCountries?uid=${uid}`}
                        countryChange={selectedCountry => {
                          setSelectedCountry(selectedCountry);
                        }}
                      />
                    )}
                    {IsCEO() && (
                      <GetAllCountries
                        showAllCountry={false}
                        countryChange={selectedCountry => {
                          setSelectedCountry(selectedCountry);
                        }}
                      />
                    )}
                  </div>
                  <ExecutiveDashboard selectedCountry={selectedCountry} />
                </Tab>
                <Tab label={"COE"} tabName={t("dashboard.tabs.coe")}>
                  <COEDashboard country={selectedCountry} />
                </Tab>
                <Tab label={"campaign"} tabName={t("dashboard.tabs.campaign")}>
                  <div
                    className={styles.stickyHeader}
                    style={{ left: "290px" }}
                  >
                    {IsCEO() && (
                      <GetAllCountries
                        showAllCountry={false}
                        countryChange={selectedCountry => {
                          setSelectedCountry(selectedCountry);
                        }}
                      />
                    )}
                    {IsExecutive() && (
                      <GetAllCountries
                        showAllCountry={false}
                        api={`/api/getUserCountries?uid=${uid}`}
                        countryChange={selectedCountry => {
                          setSelectedCountry(selectedCountry);
                        }}
                      />
                    )}
                    <CampaignList country={selectedCountry} />
                  </div>
                  <CampaignDashboard />
                </Tab>
              </Tabs>
            ) : null}

            {IsCoachee() &&
              !IsCampaignAdmin() &&
              !IsCOEAdmin() &&
              !IsExecutive() &&
              !IsCoordinator() && <PersonalDashBoard />}
          </Section>
        </PageContent>
      </div>
    </DashboardLayout>
  );
}
